import React from "react";

const Liked = () => {
  return <div>Liked</div>;
};

export default Liked;
